var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Request } from '../';
import { Model } from './Model';
import { HttpExclude } from '../../decorators';
/**
 * Usage for processing of sending/receiving data and render data.
 * This is a special Model that handles CRUDs (create, read, update and delete).
 */
var Resource = /** @class */ (function (_super) {
    __extends(Resource, _super);
    function Resource() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The endpoint of this resource.
         * It is possible to use paths inside brackets in order to use dynamic endpoints.
         * ```typescript
         * import {Resource} from 'simpli-web-sdk'
         *
         * export class User extends Resource {
         *   $endpoint: string = '/user{/id}'
         *   ...
         * }
         *
         * async function example() {
         *   const user = new User()
         *   await user.$action
         *     .query({id: 1}) // generates a Request instance equivalent of: GET /user/1
         *     .as(user)
         *     .getResponse()
         * }
         * ```
         */
        _this.$endpoint = '';
        /**
         * The configuration of custom actions which provides the methods (GET, POST, etc.) and the URL.
         * This config is applied in $action.
         * ```typescript
         * import {Resource} from 'simpli-web-sdk'
         * import {Friend} from '@/model/Friend'
         *
         * export class User extends Resource {
         *   $endpoint: string = '/user{/id}'
         *   $customActionConfig = {
         *     getFriend: {
         *       methods: 'GET',
         *       url: '/user{/id}/friend{/idFriend}',
         *     },
         *   }
         *   ...
         * }
         *
         * async function example() {
         *   const user = new User()
         *   const friend = new Friend()
         *   await user.$action
         *     .getFriend({id: 1, idFriend: 2}) // generates a Request instance equivalent of: GET /user/1/friend/2
         *     .as(friend)
         *     .getResponse()
         * }
         * ```
         */
        _this.$customActionConfig = {};
        /**
         * Any extra configuration from axios.
         * https://github.com/axios/axios#request-config
         * ```typescript
         * import {Resource} from 'simpli-web-sdk'
         *
         * export class User extends Resource {
         *   $axiosConfig = {
         *     // `headers` are custom headers to be sent
         *     headers: {'X-Requested-With': 'XMLHttpRequest'},
         *   }
         *   ...
         * }
         * ```
         */
        _this.$axiosConfig = {};
        return _this;
    }
    Object.defineProperty(Resource.prototype, "$tag", {
        /**
         * The getter that represents a tag (optional).
         * Used in [[InputSelect]] component.
         * ```typescript
         * import {TAG, Resource} from 'simpli-web-sdk'
         *
         * export class User extends Resource {
         *   ...
         *   get $tag() {
         *     return this.name
         *   }
         *   set $tag(val: TAG) {
         *     this.name = val
         *   }
         *   name: string | null = null
         * }
         * ```
         */
        get: function () {
            return this.$id.toString();
        },
        /**
         * The setter that represents a tag (optional).
         * Used in [[InputSelect]] component.
         * ```typescript
         * import {TAG, Resource} from 'simpli-web-sdk'
         *
         * export class User extends Resource {
         *   ...
         *   get $tag() {
         *     return this.name
         *   }
         *   set $tag(val: TAG) {
         *     this.name = val
         *   }
         *   name: string | null = null
         * }
         * ```
         */
        set: function (val) {
            /**/
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "$action", {
        /**
         * Invokes a request based on the $endpoint and the $customActionConfig.
         * There are four default action:
         * - query: { method: 'GET', url: $endpoint },
         * - save: { method: 'POST', url: $endpoint },
         * - update: { method: 'PUT', url: $endpoint },
         * - remove: { method: 'DELETE', url: $endpoint },
         * ```typescript
         * import {ID, Resource} from 'simpli-web-sdk'
         *
         * export class User extends Resource {
         *   $endpoint: string = '/user{/id}'
         *   get $id() {
         *     return this.id || 0
         *   }
         *   set $id(val: ID) {
         *     this.id = val
         *   }
         *
         *   id: ID = 0
         *   name: string | null = null
         * }
         *
         * async function example1() {
         *   const user = new User()
         *   await user.$action
         *     .query({id: 1}) // generates a Request instance equivalent of: GET /user/1
         *     .as(user)
         *     .getResponse()
         * }
         *
         * async function example2() {
         *   const user = new User()
         *   user.name = 'Michael Jackson'
         *   await user.$action
         *     .save(user) // generates a Request instance equivalent of: POST /user
         *     .asAny()
         *     .getResponse()
         * }
         * ```
         */
        get: function () {
            var endpoint = this.$endpoint;
            var customActionConfig = this.$customActionConfig;
            var axiosConfig = this.$axiosConfig;
            var action = {};
            var defaultActionConfig = {
                query: { method: 'GET', url: endpoint },
                save: { method: 'POST', url: endpoint },
                update: { method: 'PUT', url: endpoint },
                remove: { method: 'DELETE', url: endpoint },
            };
            // convert URL model into a genuine URL
            // e.g. /foo{/id1}/bar{/id2} -> /foo/10/bar/20
            var buildUrl = function (url, params) {
                var urlResult = "" + url;
                // extract bracket params ({/id1}, {/id2}, etc.)
                var bracketParams = url.match(/{\/\w+}/g) || [];
                for (var _i = 0, bracketParams_1 = bracketParams; _i < bracketParams_1.length; _i++) {
                    var param = bracketParams_1[_i];
                    var result = /{\/(\w+)}/g.exec(param);
                    var paramKey = result ? result[1] : null;
                    var value = params && paramKey && params[paramKey] ? "/" + params[paramKey] : '';
                    urlResult = urlResult.replace(param, value);
                    if (params && paramKey && params[paramKey] !== undefined) {
                        delete params[paramKey];
                    }
                }
                return urlResult;
            };
            var actionConfig = Object.assign(defaultActionConfig, customActionConfig);
            var _loop_1 = function (key) {
                var url = actionConfig[key].url;
                var method = actionConfig[key].method.toLowerCase();
                action[key] = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var params = {};
                    var data = undefined;
                    switch (args.length) {
                        case 2:
                            params = args[0];
                            data = args[1];
                            break;
                        case 1:
                            if (['post', 'put', 'patch'].includes(method)) {
                                data = args[0];
                            }
                            else {
                                params = args[0];
                            }
                            break;
                        case 0:
                            break;
                        default:
                            throw Error("Expected up to 2 arguments [params, data], got " + args.length + " arguments");
                    }
                    axiosConfig.params = {};
                    var buildedUrl = buildUrl(url, params);
                    Object.assign(axiosConfig.params, params);
                    if (data) {
                        // @ts-ignore
                        return Request[method](buildedUrl, data, axiosConfig);
                    }
                    // @ts-ignore
                    return Request[method](buildedUrl, axiosConfig);
                };
            };
            for (var key in actionConfig) {
                _loop_1(key);
            }
            return action;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "$allParamKeys", {
        /**
         * Gets all param keys from the endpoint
         * ```typescript
         * import {Resource} from 'simpli-web-sdk'
         *
         * export class User extends Resource {
         *   $endpoint: string = '/user{/id1}{/id2}'
         *   ...
         * }
         *
         * async function example() {
         *   const user = new User()
         *   console.log(user.$allParamKeys) // ['id1', 'id2']
         * }
         * ```
         */
        get: function () {
            var allParamKeys = [];
            // extract bracket params ({/id1}, {/id2}, etc.)
            var bracketParams = this.$endpoint.match(/{\/\w+}/g) || [];
            for (var _i = 0, bracketParams_2 = bracketParams; _i < bracketParams_2.length; _i++) {
                var param = bracketParams_2[_i];
                var result = /{\/(\w+)}/g.exec(param);
                var paramKey = result ? result[1] : null;
                if (paramKey)
                    allParamKeys.push(paramKey);
            }
            return allParamKeys;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "$firstParamKey", {
        /**
         * Gets the first param key from the endpoint
         * ```typescript
         * import {Resource} from 'simpli-web-sdk'
         *
         * export class User extends Resource {
         *   $endpoint: string = '/user{/id1}{/id2}'
         *   ...
         * }
         *
         * async function example() {
         *   const user = new User()
         *   console.log(user.$firstParamKey) // 'id1'
         * }
         * ```
         */
        get: function () {
            return this.$allParamKeys[0] || null;
        },
        enumerable: true,
        configurable: true
    });
    Resource.prototype.$getOne = function () {
        var ids = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            ids[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var params, allParamKeys;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {};
                        allParamKeys = this.$allParamKeys;
                        if (ids.length !== allParamKeys.length) {
                            throw Error("Expected " + allParamKeys.length + " arguments, got " + ids.length + " arguments");
                        }
                        allParamKeys.forEach(function (paramKey, index) { return (params[paramKey] = ids[index]); });
                        return [4 /*yield*/, this.$action
                                .query(params)
                                .name(this.$getSpinnerName('getOne'))
                                .as(this)
                                .getResponse()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Resource.prototype.$getMany = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$action
                            .query(params)
                            .name(this.$getSpinnerName('getMany'))
                            .asArrayOf(this.$clone())
                            .getResponse()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Resource.prototype.$query = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$action
                            .query(params)
                            .name(this.$getSpinnerName('query'))
                            .as(this)
                            .getResponse()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Resource.prototype.$save = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$action
                            .save(params, this)
                            .name(this.$getSpinnerName('save'))
                            .asAny()
                            .getResponse()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Resource.prototype.$update = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var firstParamKey, localParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        firstParamKey = this.$firstParamKey;
                        localParams = {};
                        if (firstParamKey && this.$id) {
                            localParams[firstParamKey] = this.$id;
                        }
                        return [4 /*yield*/, this.$action
                                .update(Object.assign(localParams, params), this)
                                .name(this.$getSpinnerName('update'))
                                .asAny()
                                .getResponse()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Resource.prototype.$remove = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var firstParamKey, localParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        firstParamKey = this.$firstParamKey;
                        localParams = {};
                        if (firstParamKey && this.$id) {
                            localParams[firstParamKey] = this.$id;
                        }
                        return [4 /*yield*/, this.$action
                                .remove(Object.assign(localParams, params))
                                .name(this.$getSpinnerName('remove'))
                                .asAny()
                                .getResponse()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    __decorate([
        HttpExclude(),
        __metadata("design:type", String)
    ], Resource.prototype, "$endpoint", void 0);
    __decorate([
        HttpExclude(),
        __metadata("design:type", Object)
    ], Resource.prototype, "$customActionConfig", void 0);
    __decorate([
        HttpExclude(),
        __metadata("design:type", Object)
    ], Resource.prototype, "$axiosConfig", void 0);
    return Resource;
}(Model));
export { Resource };
//# sourceMappingURL=Resource.js.map